module.exports = __webpack_public_path__ + "static/media/31-7.580b2175.mp3";